<template>
    <!-- 票台管理 － 售票信息 -->
    <div>
        <content-view class="ticketSaleInfo" v-show="$utils.renderWhen(this,'cashierRetailInfo')">
            <div slot="header">
                <a-form :form="form" layout="inline">
                        <span class="ml16" style="display: inline-block; margin-top: 5px;">绑定仓库：{{warehouseInfo.warehouseName || '--'}}</span>
                    <a-form-item label="商品名称">
                        <a-input placeholder="请输入" v-decorator="['goodsName']"></a-input>
                    </a-form-item>
                    <!-- <a-form-item label="类型" v-if="selfIsUse">
                        <a-select :options="typeOptions" v-decorator="['goodsCategoryId']" placeholder="请选择" allowClear ></a-select>
                    </a-form-item> -->
                    <a-form-item label="类型" v-if="kingDiskIsUse">
                        <a-input placeholder="请输入" v-decorator="['goodsGroup']"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <a-tabs :defaultActiveKey="1" :animated="false" @change="changeTab">
                    <a-tab-pane tab="绑定且展示至该票台" :key="1">
                    </a-tab-pane>
                    <a-tab-pane tab="绑定且不展示至该票台" :key="0">
                    </a-tab-pane>
                </a-tabs>
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="record => record.id"
                    :loading="loading"
                    >
                    <span slot="index" slot-scope="a, row, index">{{index+1}}</span>
                    <span slot="isShow" slot-scope="key">{{key ? '已展示' : '不展示'}}</span>
                    <template slot="empty" slot-scope="key, row, index">
                        {{key !== null ? key : "-"}}
                    </template>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('cashierProductDetail')">
                            <a class="text-primary" @click="toTicketDetail(row)">详情</a>
                            <a-divider type="vertical"/>
                        </span>
                        <a-popconfirm
                            v-if="getBtnByAuth('retailToShelf')"
                            :title="`确定将票台上的该门店零售商品${row.isShow ? '不展' : '展'}示至该票台吗?`"
                            @confirm="changeState(row.id, !row.isShow)"
                            >
                            <a class="text-primary">{{row.isShow ? '不展' : '展'}}示至该票台</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    //  默认表头
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "名称",
            dataIndex: "goodsName",
            width: 100,
        },
        {
            title: "类型",
            dataIndex: "categoryName"
        },
        {
            title: "当前库存",
            dataIndex: "availableInventory"
        },
        {
            title: "销量",
            dataIndex: "totalSales"
        },
        {
            title: "售价",
            dataIndex: "sellPrice",
            scopedSlots: {customRender: 'empty'}
        },
        {
            title: "状态",
            dataIndex: "isShow",
            scopedSlots: { customRender: "isShow" }
        },
        {
            title: "操作",
            scopedSlots: { customRender: "action" }
        }]
    export default {
        name: "retailInfo",
        components: {},
        props: {},
        data() {
            return {
                columns,
                noTitleKey: 1,
                typeOptions: [],
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    current: 1,
                    pageSize: 20,
                    total: 0,
                },
                form: null,
                kingDiskIsUse: false,
                selfIsUse: false,
                warehouseInfo: {},
                loading: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            shopId() {
                this.$router.back();
            }
        },
        methods: {
            toTicketDetail(item) {
                this.$router.push({ name: 'retailInfoDetail', params: {id: item.id}})
            },
            handleReset () {
                this.form.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.getCounterGoods();
            },
            changeTab(key) {
                this.noTitleKey = key;
                this.pagination.current= 1;
                this.getCounterGoods();
            },
            // 获取审核管理我发起的表格分页数据
            changePage(page) {
                this.pagination = page;
                this.getCounterGoods();
            },
            /**
             * @getGoodsCateList 获取商品类别
             */
            getGoodsCateList() {
                this.$api.newStorage.getSelfGoodsCateList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.label = item.categoryName;
                            item.value = item.id;
                        });
                        this.typeOptions = res;
                    }
                });
            },
            // 获取商品信息列表
            getCounterGoods() {
                if (!Boolean(this.shopId) || this.loading) {
                    return false;
                }
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    this.$api.ticketDesk.counterGoodsPage({
                        body: {
                            ...values,
                            "counterId": this.$route.params.rid,
                            "isShow": this.noTitleKey,
                            "pageNum": this.pagination.current,
                            "pageSize": this.pagination.pageSize,
                            "shopId": this.shopId
                        }
                    }).then(res => {
                        this.loading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                        this.warehouseInfo = res.exParameter || {};
                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            // 修改状态
            changeState(id, isShow) {
                if (this.loading) {
                    return false;
                }
                let currentItem = this.dataSource.find(item => item.id === id);
                if (isShow && currentItem.sellPrice === null) {
                    this.$message.error('此商品未设置售卖价，无法上架！');
                    return false;
                }
                if (isShow && !Boolean(currentItem.availableInventory)) {
                    this.$message.error('此商品暂无库存，无法上架！');
                    return false;
                }
                this.loading = true;
                this.$api.ticketDesk.goodsShelveState({
                    body: {
                        goodsId: id,
                        isShow: isShow,
                        counterId: this.$route.params.rid,
                        shopId: this.shopId,
                        userId: this.userInfo.id,
                        account: this.userInfo.account,
                        username: this.userInfo.name
                    }
                }).then(data=>{
                    this.$message.success('操作成功');
                    this.loading = false;
                    this.getCounterGoods();
                }).catch(err => {
                    this.loading = false;
                })
            },
            /**
             * @sysIsUse 是否使用该系统
             */
            sysIsUse(systemType) {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.sysIsUse({
                    query: {
                        shopId: this.shopId,
                        systemType
                    }
                }).then(res => {
                    if (systemType === 0) {
                        this.kingDiskIsUse = Boolean(res.isUse);
                    } else {
                        this.selfIsUse = Boolean(res.isUse);
                    }
                });
            }
        },
        beforeCreate() {
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            this.sysIsUse(0);
            this.sysIsUse(1);
            this.getGoodsCateList();
            this.getCounterGoods();
        }
    };
</script>
<style lang="scss">
</style>
